import Spinner from "@atlaskit/spinner";

export default function AtkLoader(props: any) {
  return (
    <div className="custom-spinner">
      <Spinner appearance="inherit" size="medium" />
    </div>
  );
}